export enum UserRole {
    User = 'User',
    Member = 'Member',
    Anonymous = 'Anonymous'
}